// @flow

import styled from "@emotion/styled";
import { SystemCSSProperties } from "@chakra-ui/react";

import * as spacing from "src/styles/constants/spacing";
import * as colors from "src/styles/constants/colors";
import { SelectionMultiple } from "src/styles/dropdown";

export const Settings = styled.div`
  padding: 15px 12.5px;
  text-align: left;
  background-color: ${colors.brightLight};
  width: 100%;
  margin-bottom: 5.25rem;
`;

export const Label = styled.div`
  color: ${colors.primary};
  font-size: 14px;
  margin-bottom: ${spacing.space_m};
`;

export const SecondaryLabel = styled.p`
  color: ${colors.grey5};
  font-size: 12px;
  margin-bottom: ${spacing.space_m};
`;

export const FormGroup = styled.div`
  margin-bottom: 0;
`;

export const FormGroupSmall = styled.div`
  margin-bottom: 0;
  width: min-content;
`;

export const Sort = styled(FormGroup)`
  display: flex;
  align-items: center;
  > div {
    margin-left: 0.8em;
  }
`;

export const Footer = styled.div`
  display: flex;
  margin-top: ${spacing.space_l};
  justify-content: space-between;
`;

export const FileSelect = styled.div`
  input {
    margin: 0;
  }
  ${SelectionMultiple} {
    padding: 0;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const CheckboxWrapper = styled.div`
  padding-top: 0.5em;
  padding-bottom: 0.2em;
`;

export const SelectedFormWrapper = styled.div`
  > div {
    margin-bottom: 0.4em;
    padding: 0.5em 0.6em;
  }
`;

export const SectionContainer: SystemCSSProperties = {
  minHeight: "105px"
};

export const SectionWrapper: SystemCSSProperties = {
  alignItems: "center",
  justifyContent: "flex-start",
  flexWrap: "wrap"
};

export const InputWrapper = styled.div`
  max-width: 24rem;
`;

// FIXME: Change color to token when available
export const ErrorLine = styled.span`
  font-size: 12px;
  color: #d92d20;
`;

export const SettingsField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  input {
    width: 24.5rem;
  }
`;

export const AccordionVStack = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: 14px;
  gap: 1rem;
  margin: 1rem 0rem !important;
`;

export const ErrorMessage = styled.p`
  color: ${colors.red500};
  font-style: normal;
  font-size: 12px;
  line-height: 16px;
  margin-top: 4px;
`;
